import {SagaIterator} from 'redux-saga';
import {select} from 'typed-redux-saga';

import {State} from 'app/setup';

/**
 * Loads the version string for a saved animal list.
 *
 * @param id Saved animal-list id.
 * @returns The saved list version used for overwrite and rename flows.
 */
export function* getAnimalListVersion(id: number): SagaIterator<string> {
    const animalLists = yield* select((state: State) => state.animalBrowser.animalLists);
    const animalListVersion = animalLists
        .findIn(y => y.id === id)
        .prop('version')
        .orCrash('animalLists not available');

    return animalListVersion;
}
